'use client'

import { callHandler, configurePage, initSdk, isWebBridgeSupported, resetSdk } from '@shopee/web-bridge-sdk'
import { configAxios } from 'axios-settings/config'
import GetSearchParams from 'components/GetSearchParams'
import Messages from 'components/Messages'
import OpenShopeeApp from 'components/OpenShopeeApp'
import { useEffect } from 'react'
import { Provider } from 'react-redux'
import store from 'redux/store'
import { initTracking } from 'shared/tracking'

const PageLayout = ({ children }: { children: any }) => {
  useEffect(() => {
    try {
      initSdk()
      configurePage({
        config: {
          disableReload: 1,
          disableBounce: 1,
        },
        navbar: {
          isTransparent: 1,
          hideBackButton: 1,
        },
      })
      // @ts-ignore
      callHandler('adjustWebViewInsets', {
        customTopInset: -999,
        customLeftInset: -999,
        customRightInset: -999,
        customBottomInset: -999,
      })
      initTracking()

      const updateScreenSize = () => {
        document.documentElement.style.setProperty('--screen-width', `${window.innerWidth}px`)
        document.documentElement.style.setProperty('--screen-height', `${window.innerHeight}px`)
      }

      if (!isWebBridgeSupported()) {
        window.addEventListener('resize', updateScreenSize)
        updateScreenSize()
      }

      return () => {
        resetSdk()
        window.removeEventListener('resize', updateScreenSize)
      }
    } catch (e) {
      console.log('err', e)
    }
  }, [])

  configAxios()

  return (
    <Provider store={store}>
      {children}
      <GetSearchParams />
      <Messages />
      <OpenShopeeApp />
    </Provider>
  )
}

export default PageLayout
